import ModuleList from '../moduleList'
const routes = [
  {
    path: '/',
    component: ModuleList
  },
  {
    path: '/channel',
    component: ModuleList
  },
  {
    path: '/test',
    component: ModuleList
  },
  {
    path: '/nodeprotest',
    component: ModuleList
  }
]

export default routes
